/**
 * @module tree/invoke
 */

/**
 * @typedef {HTMLTemplateElement} Template
 * @typedef {DocumentFragment} Fragment
 */

/**
 * Invokes a template content
 * @param {Template} template
 * @returns {Fragment}
 */
export default (
  template
) => {
  const { content, ownerDocument } = template
  
  return ownerDocument.importNode(content, true)
}
